module.exports = __webpack_public_path__ + "static/media/Lockbanner2.19e634fe.svg";